/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ResponseObject,
  ResponseObject$inboundSchema,
  ResponseObject$Outbound,
  ResponseObject$outboundSchema,
} from "./responseobject.js";

export type ResponseIncompleteEvent = {
  type: "response.incomplete";
  sequenceNumber: number;
  response: ResponseObject;
};

/** @internal */
export const ResponseIncompleteEvent$inboundSchema: z.ZodType<
  ResponseIncompleteEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.incomplete"),
  sequence_number: z.number().int(),
  response: ResponseObject$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
  });
});
/** @internal */
export type ResponseIncompleteEvent$Outbound = {
  type: "response.incomplete";
  sequence_number: number;
  response: ResponseObject$Outbound;
};

/** @internal */
export const ResponseIncompleteEvent$outboundSchema: z.ZodType<
  ResponseIncompleteEvent$Outbound,
  z.ZodTypeDef,
  ResponseIncompleteEvent
> = z.object({
  type: z.literal("response.incomplete"),
  sequenceNumber: z.number().int(),
  response: ResponseObject$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
  });
});

export function responseIncompleteEventToJSON(
  responseIncompleteEvent: ResponseIncompleteEvent,
): string {
  return JSON.stringify(
    ResponseIncompleteEvent$outboundSchema.parse(responseIncompleteEvent),
  );
}
export function responseIncompleteEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseIncompleteEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseIncompleteEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseIncompleteEvent' from JSON`,
  );
}
